import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <main
      id="MainContent"
      className="main-content content-for-layout focus-none"
      role="main"
      tabIndex={-1}
    >
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Privacy policy</h1>
        </div>
        <div className="shopify-policy__body">
          <div className="rte">
            <p>
              <span>
                This Privacy Policy describes how pedarcircle.club (the “Site”
                or “we”) collects, uses, and discloses your Personal Information
                when you visit or make a purchase from the Site.
              </span>
            </p>
            <h2>Collecting Personal Information</h2>
            <p>
              <span>
                When you visit the Site, we collect certain information about
                your device, your interaction with the Site, and information
                necessary to process your purchases. We may also collect
                additional information if you contact us for customer support.
                In this Privacy Policy, we refer to any information that can
                uniquely identify an individual (including the information
                below) as “Personal Information”. See the list below for more
                information about what Personal Information we collect and why.
              </span>
            </p>
            <h4>
              <strong>Device information</strong>
            </h4>
            <ul>
              <li>
                <b>Examples of Personal Information collected: </b>
                <span>
                  version of web browser, IP address, time zone, cookie
                  information, what sites or products you view, search terms,
                  and how you interact with the Site.
                </span>
              </li>
              <li>
                <b>Purpose of collection: </b>
                <span>
                  to load the Site accurately for you, and to perform analytics
                  on Site usage to optimise our Site.
                </span>
              </li>
              <li>
                <b>Source of collection: c</b>
                <span>
                  ollected automatically when you access our Site using cookies,
                  log files, web beacons, tags, or pixels.
                </span>
              </li>
              <li>
                <b>Disclosure for a business purpose: </b>
                <span>
                  shared with our processor Shopify and our analytics platforms
                  Google Adwords, Microsoft and Google Analytics.
                </span>
              </li>
            </ul>
            <h4>
              <strong>Order information</strong>
            </h4>
            <ul>
              <li>
                <b>Examples of Personal Information collected: </b>
                <span>
                  name, billing address, shipping address, payment information
                  (including credit card numbers), email address, and phone
                  number.
                </span>
              </li>
              <li>
                <b>Purpose of collection: </b>
                <span>
                  to provide products or services to you to fulfil our contract,
                  to process your payment information, arrange for shipping, and
                  provide you with invoices and/or order confirmations,
                  communicate with you, screen our orders for potential risk or
                  fraud, and when in line with the preferences you have shared
                  with us, provide you with information or advertising relating
                  to our products or services.
                </span>
              </li>
              <li>
                <b>Source of collection: </b>
                <span>collected from you.</span>
              </li>
              <li>
                <b>Disclosure for a business purpose: </b>
                <span>
                  shared with our processor Shopify and our warehouse management
                  system DespatchCloud.
                </span>
              </li>
            </ul>
            <h4>
              <strong>Customer support information</strong>
            </h4>
            <ul>
              <li>
                <b>Examples of Personal Information collected: </b>
                <span>
                  name, billing address, shipping address, payment information
                  (including credit card numbers), email address and phone
                  number.
                </span>
              </li>
              <li>
                <b>Purpose of collection: </b>
                <span>to provide customer support.</span>
              </li>
              <li>
                <b>Source of collection: </b>
                <span>collected from you.</span>
              </li>
              <li>
                <b>Disclosure for a business purpose: </b>
                <span>
                  shared with our processor Shopify, our customer service
                  software platform Dixa and our review platforms Trustpilot and
                  Google Reviews.
                </span>
              </li>
            </ul>
            <h4>
              <strong>Marketing Information</strong>
            </h4>
            <ul>
              <li>
                <b>Examples of Personal Information collected: </b>
                <span>
                  name, address, email address and phone number (SMS).
                </span>
              </li>
              <li>
                <b>Purpose of collection: </b>t
                <span>
                  o share information about products and offers that you may be
                  interested in.
                </span>
              </li>
              <li>
                <b>Source of collection: </b>
                <span>
                  collected from you when you sign up for our newsletter or opt
                  in for email or SMS marketing when making a purchase.
                </span>
              </li>
              <li>
                <b>Disclosure for a business purpose: </b>
                <span>
                  shared with our processor Shopify and email marketing platform
                  Klaviyo.
                </span>
              </li>
            </ul>
            <h3>Minors</h3>
            <p>
              <span>
                The Site is not intended for individuals under the age of 18. We
                do not intentionally collect Personal Information from children.
                If you are the parent or guardian and believe your child has
                provided us with Personal Information, please contact us at the
                address below to request deletion.
              </span>
            </p>
            <h2>
              <strong>Sharing Personal Information</strong>
            </h2>
            <p>
              <span>
                We share your Personal Information with service providers to
                help us provide our services and fulfil our contracts with you,
                as described above. For example:
              </span>
            </p>
            <ul>
              <li>
                <span>
                  We use Shopify to power our online store. You can read more
                  about how Shopify uses your Personal Information here:{" "}
                </span>
                <Link onClick={toTop} to="/privacy">
                  <span>Privacy</span>
                </Link>
                <span>.</span>
              </li>
              <li>
                <span>
                  We may share your Personal Information to comply with
                  applicable laws and regulations, to respond to a subpoena,
                  search warrant or other lawful request for information we
                  receive, or to otherwise protect our rights.
                </span>
              </li>
            </ul>
            <p>
              <br />
            </p>
            <h2>Behavioural Advertising</h2>
            <p>
              <span>
                As described above, we use your Personal Information to provide
                you with targeted advertisements or marketing communications we
                believe may be of interest to you. For example:
              </span>
            </p>
            <ul>
              <li>
                <span>
                  We use Google Analytics to help us understand how our
                  customers use the Site. You can read more about how Google
                  uses your Personal Information here:{" "}
                </span>
                <Link onClick={toTop} to="/privacy">
                  <span>Privacy</span>
                </Link>
              </li>
            </ul>
            <p>
              <span>
                For more information about how targeted advertising works, you
                can visit the Network Advertising Initiative’s (“NAI”)
                educational page at{" "}
              </span>
              <Link onClick={toTop} to="/">
                <span>Home</span>
              </Link>
              <span>.</span>
            </p>

            <p>
              <span>
                Additionally, you can opt out of some of these services by
                visiting the Digital Advertising Alliance’s opt-out portal at:{" "}
              </span>
              <Link onClick={toTop} to="/">
                <span>Home</span>
              </Link>
              <span>.</span>
            </p>
            <h2>
              <strong>Using Personal Information</strong>
            </h2>
            <p>
              <span>
                We use your personal Information to provide our services to you,
                which includes: offering products for sale, processing payments,
                shipping and fulfi
              </span>
              <span>
                lment of your order, and keeping you up to date on new products,
                services, and offers.
              </span>
            </p>
            <h3>
              <strong>Lawful basis</strong>
            </h3>
            <p>
              <span>
                Pursuant to the General Data Protection Regulation (“GDPR”), if
                you are a resident of the European Economic Area (“EEA”), we
                process your personal information under the following lawful
                bases:
              </span>
            </p>
            <ul>
              <li>
                <span>Your consent;</span>
              </li>
              <li>
                <span>
                  The performance of the contract between you and the Site;
                </span>
              </li>
              <li>
                <span>Compliance with our legal obligations;</span>
              </li>
              <li>
                <span>To protect your vital interests;</span>
              </li>
              <li>
                <span>
                  To perform a task carried out in the public interest;
                </span>
              </li>
              <li>
                <span>
                  For our legitimate interests, which do not override your
                  fundamental rights and freedoms.
                </span>
              </li>
            </ul>
            <h3>Retention</h3>
            <p>
              <span>
                When you place an order through the Site, we will retain your
                Personal Information for our records unless and until you ask us
                to erase this information. For more information on your right of
                erasure, please see the ‘Your rights’ section below.
              </span>
            </p>
            <h3>Automatic decision-making</h3>
            <p>
              <span>
                If you are a resident of the EEA, you have the right to object
                to processing based solely on automated decision-making (which
                includes profiling), when that decision-making has a legal
                effect on you or otherwise significantly affects you.
              </span>
            </p>
            <p>
              <span>
                We do not engage in fully automated decision-making that has a
                legal or otherwise significant effect using customer data.
              </span>
            </p>
            <p>
              <span>
                Our processor Shopify uses limited automated decision-making to
                prevent fraud that does not have a legal or otherwise
                significant effect on you.
              </span>
            </p>
            <p>
              <span>
                Services that include elements of automated decision-making
                include:
              </span>
            </p>
            <ul>
              <li>
                <span>
                  Temporary denylist of IP addresses associated with repeated
                  failed transactions. This denylist persists for a small number
                  of hours.
                </span>
              </li>
              <li>
                <span>
                  Temporary denylist of credit cards associated with denylisted
                  IP addresses. This denylist persists for a small number of
                  days.
                </span>
              </li>
            </ul>
            <h2>Your rights</h2>
            <h3>GDPR</h3>
            <p>
              <span>
                If you are a resident of the EEA, you have the right to access
                the Personal Information we hold about you, to port it to a new
                service, and to ask that your Personal Information be corrected,
                updated, or erased. If you would like to exercise these rights,
                please contact us at draft@pedarcircle.club
              </span>
            </p>
            <p>
              <span>
                Your Personal Information will be initially processed in Ireland
                and then will be transferred outside of Europe for storage and
                further processing, including to Canada and the United States.
                For more information on how data transfers comply with the GDPR,
                see Shopify’s GDPR Whitepaper:{" "}
              </span>
              <Link onClick={toTop} to="/privacy">
                <span>Privacy</span>
              </Link>
              <span>.</span>
            </p>
            <p>
              <br />
            </p>
            <h3>Cookies</h3>
            <p>
              A cookie is a small amount of information that’s downloaded to
              your computer or device when you visit our Site. We use a number
              of different cookies which fall into the various categories
              described below. Cookies make your browsing experience better by
              allowing the website to remember your actions and preferences
              (such as login and region selection). This means you don’t have to
              re-enter this information each time you return to the site or
              browse from one page to another. Cookies also provide information
              on how people use the website, for instance whether it’s their
              first time visiting or if they are a frequent visitor.
            </p>
            <h4>Strictly Required Cookies, only</h4>
            <p>
              These cookies are required for the website to run and cannot be
              switched off. Such cookies are only set in response to actions
              made by you such as language, currency, login session, privacy
              preferences. You can set your browser to block these cookies but
              this might affect the way our site is working.
            </p>
            <h4>Analysis &amp; Statistics Cookies</h4>
            <p>
              These cookies allow us to measure visitors traffic and see traffic
              sources by collecting information in data sets. They also help us
              understand which products and actions are more popular than
              others.
            </p>
            <h3>
              <br />
            </h3>
            <h4>Marketing and Retargeting Cookies</h4>
            <p>
              These cookies are usually set by our marketing and advertising
              partners. They may be used by them to build a profile of your
              interest and later show you relevant ads. If you do not allow
              these cookies you will not experience targeted ads for your
              interests.
            </p>
            <h4>Functional Cookies</h4>
            <p>
              These cookies enable our website to offer additional functions and
              personal settings. They can be set by us or by third-party service
              providers that we have placed on our pages. If you do not allow
              these cookies, these or some of these services may not work
              properly.
            </p>
            <h4>Managing Cookies</h4>
            <p>
              <span>
                The length of time that a cookie remains on your computer or
                mobile device depends on whether it is a “persistent” or
                “session” cookie. Session cookies last until you stop browsing
                and persistent cookies last until they expire or are deleted.
                Most of the cookies we use are persistent and will expire
                between 30 minutes and two years from the date they are
                downloaded to your device.
              </span>
            </p>
            <p>
              <span>You can control and manage cookies in various ways. </span>
              <span>
                Most browsers automatically accept cookies, but you can choose
                whether or not to accept cookies through your browser controls,
                often found in your browser’s “Tools” or “Preferences” menu. For
                more information on how to modify your browser settings or how
                to block, manage or filter cookies can be found in your
                browser’s help file or through such sites as{" "}
              </span>
              <Link onClick={toTop} to="/">
                <span>Home</span>
              </Link>
              <span>.</span>
            </p>
            <p>
              <span>
                Additionally, please note that blocking cookies may not
                completely prevent how we share information with third parties
                such as our advertising partners. To exercise your rights or
                opt-out of certain uses of your information by these parties,
                please follow the instructions in the “Behavioural Advertising”
                section above.
              </span>
            </p>
            <p>
              Please keep in mind that removing or blocking cookies can
              negatively impact your user experience and parts of our website
              may no longer be fully accessible.
            </p>
            <h4>Do Not Track</h4>
            <p>
              <span>
                Please note that because there is no consistent industry
                understanding of how to respond to “Do Not Track” signals, we do
                not alter our data collection and usage practices when we detect
                such a signal from your browser.
              </span>
            </p>
            <h4>Changes</h4>
            <p>
              <span>
                We may update this Privacy Policy from time to time in order to
                reflect, for example, changes to our practices or for other
                operational, legal, or regulatory reasons.
              </span>
            </p>
            <h3>Contact</h3>
            <p>
              <span>
                For more information about our privacy practices, if you have
                questions, or if you would like to make a complaint, please
                contact us by e-mail at{" "}
              </span>
              <Link onClick={toTop} to="mailto:draft@pedarcircle.club">
                <span>draft@pedarcircle.club</span>
              </Link>
              <span>or by mail using the details provided below: </span>
            </p>
            <p>
              <span>
                Pedarcircle, Unit C1 - 22 Gwynne St, Ashcroft NSW 2168 AU
              </span>
            </p>

            <p>
              <br />
              <span>
                You have the right to make a complaint at any time to the
                Information Commissioner’s Office (ICO), the UK supervisory
                authority for data protection issues (
              </span>
              <Link onClick={toTop} to="/">
                <span>Home</span>
              </Link>
              <span>
                ). We would, however, appreciate the chance to deal with your
                concerns before you approach the ICO, so please contact us in
                the first instance at{" "}
              </span>
              <Link onClick={toTop} to="mailto:draft@pedarcircle.club">
                <span>draft@pedarcircle.club</span>
              </Link>
              <span>.</span>
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Privacy;
